import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { getSheetDataState } from "features/Sheets";
import { UserArea } from "features/../../../shared/constants/enums";
import { withCurrentUser } from "features/../../../shared/components/auth";

const ImpersonatedUserUserAreaCheck = ({
  currentUser,
  restrictTo,
  children,
}) => {
  const { impersonatedUser } = useSelector(getSheetDataState);

  if (impersonatedUser?.userArea != null) {
    return restrictTo.some((area) => area === impersonatedUser.userArea) ? (
      <React.Fragment>{children}</React.Fragment>
    ) : null;
  }

  if (restrictTo.some((area) => area === currentUser.userArea)) {
    return <React.Fragment>{children}</React.Fragment>;
  }

  return null;
};

ImpersonatedUserUserAreaCheck.propTypes = {
  restrictTo: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
};

ImpersonatedUserUserAreaCheck.defaultProps = {
  restrictTo: [],
  children: null,
};

export default withCurrentUser(ImpersonatedUserUserAreaCheck);
